import { useSectionRows } from "@/components/interview/useSectionRows";
import { CATEGORY_SLUGS } from "@shared/constants/categories";
import { SECTION_SLUGS } from "@shared/constants/sections";
import { FIELD_KEYS } from "@shared/constants/fields";

/**
 * PLAN-HOME-1 (s228) — the planner's first-named executor, first name only: the person board 12 writes as "Sarah"
 * ("tasks are ready for Sarah", the Executor tab's preview line). Read through the exec screen's own row hook, so it
 * is the same record chapter one writes. "" when no executor is named yet.
 */
export function useExecutorFirstName(clientId: string): string {
  const { rows } = useSectionRows(clientId, CATEGORY_SLUGS.LEGAL, SECTION_SLUGS.LEGAL_YOUR_EXECUTOR, () => {});
  const name = rows.find((r) => !r.hidden && (r.values[FIELD_KEYS.NAME] ?? "").trim())?.values[FIELD_KEYS.NAME] ?? "";
  return name.trim().split(/\s+/)[0] ?? "";
}

/** When no executor is named yet, the board's sentences say this instead of a name (s228, reported for wording). */
export const NO_EXECUTOR_YET = "your executor";
